'use client'

import { makeRange } from '@mntn-dev/utilities'
import type { ReactNode } from 'react'
import type { FieldGridColumnSpan } from '../../../hooks/use-field-grid-field.ts'
import type { AvatarSkeletonProps } from '../../avatar/index.ts'
import { DataList, type DataListProps } from '../data-list.tsx'
import { DataListItemSkeleton } from './data-list-item-skeleton.tsx'

export type DataListSkeletonItem = {
  avatarSize?: AvatarSkeletonProps['size']
  children?: ReactNode
  className?: string
  columnSpan?: FieldGridColumnSpan
  lines?: number
}

export type DataListSkeletonProps = DataListProps & {
  items: number | DataListSkeletonItem[]
}

export const DataListSkeleton = ({
  items,
  ...dataListProps
}: DataListSkeletonProps) => {
  return (
    <DataList {...dataListProps}>
      {Array.isArray(items)
        ? items.map((item, index) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
            <DataListItemSkeleton key={index} {...item} />
          ))
        : makeRange(items).map((i) => <DataListItemSkeleton key={i} />)}
    </DataList>
  )
}
